import { eventModal } from "@NextSkyTheme/modal";

// Auto-opens the discount popup after a delay (the section only renders on the pages
// chosen in its settings — see sections/discount-popup.liquid).
// data-reopen: "always" | "session" | number of days before it may show again.
const popup = document.querySelector("discount-popup[data-auto-open='true']");

if (popup && !window.Shopify?.designMode) {
  const modal = popup.querySelector("discount-modal-popup");
  const key = `discount-popup-seen-${popup.dataset.sectionId}`;
  const mode = popup.dataset.reopen || "session";

  const alreadySeen = () => {
    try {
      if (mode === "always") return false;
      if (mode === "session") return !!sessionStorage.getItem(key);
      const last = Number(localStorage.getItem(key));
      return last && Date.now() - last < Number(mode) * 86400000;
    } catch (e) {
      return false;
    }
  };

  const markSeen = () => {
    try {
      if (mode === "session") sessionStorage.setItem(key, "1");
      else if (mode !== "always") localStorage.setItem(key, String(Date.now()));
    } catch (e) {}
  };

  if (modal && !alreadySeen()) {
    const delay = (Number(popup.dataset.autoOpenDelay) || 0) * 1000;
    setTimeout(() => {
      markSeen();
      eventModal(modal, "open", false, null, true);
    }, delay);
  }
}
